export enum RuleCondition {
  AND = 'and',
  OR = 'or',
  ANY = 'any'
}
